import { Navbar, Nav, Container } from 'react-bootstrap';
import { ReactComponent as Logo } from './CR_logo_dark.svg';

import './Navigation.css';

const Navigation = () => {
  return (
    <>
      <Navbar collapseOnSelect sticky='top' expand='md' bg="myColor" variant='dark'>
        <Container fluid>

          <Navbar.Brand href='/'>
            <Logo />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls='responsive-navbar-nav' />
          <Navbar.Collapse id='responsive-navbar-nav'>
            <Nav activeKey={window.location.pathname} className="ms-auto">
              <Nav.Link href='/'>Welcome</Nav.Link>
              <Nav.Link href='/gallery'>Gallery</Nav.Link>
              <Nav.Link href='/events'>Events</Nav.Link>
              <Nav.Link href='/commissions'>Commissions</Nav.Link>
              <Nav.Link href='/testimonials'>Testimonials</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Navigation;
